import { IFacility } from '@/types';
import dayjs from 'dayjs';
import { DateRange } from 'react-day-picker';

export function formatMonetary(val: number): string {
  return '$' + Math.round(val * 100.0) / 100.0;
}

export function cround(val: number, frac: number): number {
  const cfrag = Math.pow(10, frac);
  return Math.round(val * cfrag) / cfrag;
}

export function localReplaceAll(originalString, find, replace) {
  return originalString.replace(new RegExp(find, 'g'), replace);
}
export function stripPhoneNumber(phone) {
  if (phone) {
    const res = phone.replace(/\D/g, '');
    if (res.length > 10) {
      return res.substr(0, 10);
    }
  }
  return phone;
}

export function mapRateSearchName(item: IFacility): string {
  if (item.facility_use_ratetable && item.early_bird) {
    return 'Early Bird Rate';
  }
  if (item.facility_use_ratetable) {
    return 'Hourly Rate';
  }
  if (item.facility_hourly_selling_price) {
    return 'Hourly Rate';
  }
  if (item.facilityParkingType == 3) {
    return 'Sleep and Park';
  }
  if (item.facilityParkingType == 4) {
    return 'Monthly Park';
  }
  if (item.facility_24h_extension == 5) {
    return '12 hours max rate';
  }
  return 'day';
}

export function mapCouponError(error: string): string {
  switch (error) {
    case 'not_logged':
      return 'Please log in to redeem';
    case 'not_found':
      return 'Invalid coupon code';
    case 'member_not_found':
      return 'Invalid member name'; //
    case 'used_public':
      return 'Coupon already redeemed'; //
    case 'already_used':
      return 'This coupon has already been used';
  }
  return error;
}
export function mapReviewStars(review_avg) {
  if (!review_avg) return 4.5;
  return Math.round(review_avg * 2) / 2.0;
}

export const mapFormEncoded = (dataRequest: {}) => {
  //application/x-www-form-urlencoded;charset=UTF-8
  const formBody = [];
  for (const property in dataRequest) {
    const encodedKey = encodeURIComponent(property);
    const encodedValue = encodeURIComponent(dataRequest[property]);
    formBody.push(encodedKey + '=' + encodedValue);
  }
  return formBody.join('&');
};

const str = () =>
  (
    '00000000000000000' + (Math.random() * 0xffffffffffffffff).toString(16)
  ).slice(-16);

export const uuidv4 = () => {
  const a = str();
  const b = str();
  return (
    a.slice(0, 8) +
    '-' +
    a.slice(8, 12) +
    '-4' +
    a.slice(13) +
    '-a' +
    b.slice(1, 4) +
    '-' +
    b.slice(4)
  );
};

export const findCheapestFacility = (facilities) => {
  const validFacilities = facilities.filter(
    (facility) => facility.date_sold_out !== 1
  );

  if (validFacilities.length > 0) {
    const sortedFacilities = validFacilities.sort(
      (a, b) => a.facility_selling_price - b.facility_selling_price
    );

    return sortedFacilities[0];
  } else {
    return null;
  }
};

// default days to Airport and Cruise - used when no dates are selected
export const defaultAirportCruiseCheckIn = 5;

export const defaultAirportCruiseCheckOut = 10

// Same-day airport/cruise check-in defaults to this many hours ahead of the facility's now
export const airportCruiseSameDayLeadHours = 3;

export function getDefaultDates(isCity: boolean): DateRange {
  const now = dayjs();

  if (isCity) {
    const checkInDefault = now
      .add(30 - (now.minute() % 30), 'minute')
      .startOf('minute');
    return {
      from: checkInDefault.toDate(),
      to: checkInDefault.add(3, 'hour').toDate(),
    };
  }

  const airportCruiseCheckInDefault = now
    .add(defaultAirportCruiseCheckIn, 'day')
    .add(30 - (now.minute() % 30), 'minute')
    .startOf('minute');
  const airportCruiseCheckOutDefault = now
    .add(defaultAirportCruiseCheckOut, 'day')
    .add(30 - (now.minute() % 30), 'minute')
    .startOf('minute');

  return {
    from: airportCruiseCheckInDefault.toDate(),
    to: airportCruiseCheckOutDefault.toDate(),
  };
}

export const dateFormat = 'ddd, MMM D';
export const dateTimeFormat = 'MMMM D, YYYY h:mm A';

export const timeOptions = Array.from({ length: 48 }, (_, i) =>
  `${String(Math.floor(i / 2)).padStart(2, '0')}:${i % 2 ? '30' : '00'}`
);

// After check-in is moved to "now", checkout follows: same time of day (city: +3h when it ends the same day)
export const followCheckinTime = (checkin, checkout, isCity: boolean) => {
  if (isCity) {
    return checkout.isSame(checkin, 'day') ? checkin.add(3, 'hour') : checkout;
  }
  const next = checkout.hour(checkin.hour()).minute(checkin.minute()).second(0);
  return next.isAfter(checkin) ? next : next.add(1, 'day');
};

// localNow arrives floored to its :00/:30 slot, so a slot equal to "now" has already started
export const isPastTime = (date, time: string, now = dayjs()) => {
  if (!date || !date.isSame(now, 'day')) return false;
  const [hour, min] = time.split(':');
  return !date.hour(Number(hour)).minute(Number(min)).second(0).isAfter(now);
};

// First :00/:30 slot strictly after "now"
export const nextSlotAfter = (now) => {
  const floored = now.startOf('minute').minute(now.minute() >= 30 ? 30 : 0);
  return floored.add(30, 'minute');
};

export function getFacilityDisplayName(item: {
  facilityParkingType: number;
  facility_branded: number;
  facility_lot: string;
}): string {
  if (item.facilityParkingType === 2 || item.facility_branded === 1) {
    return item.facility_lot;
  }

  return item.facilityParkingType === 1
    ? 'Cruise Parking Deal - Limited Spots'
    : 'On Air Parking - Limited Spots';
}